// @ts-check

import BaseModel from "@kaspernj/api-maker/build/base-model.js"
import BundleOrderLine from "./bundle-order-line.js"
import PhotoSheetProductOrderLine from "./photo-sheet-product-order-line.js"

const modelClassData = {
  "attributes": {
    "bundle_tenant_photo_product_id": {
      "column": {
        "default": null,
        "name": "bundle_tenant_photo_product_id",
        "null": false,
        "type": "uuid"
      },
      "name": "bundle_tenant_photo_product_id",
      "selected_by_default": null,
      "translated": null
    },
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      },
      "name": "id",
      "selected_by_default": null,
      "translated": null
    },
    "resource_type": {
      "column": {
        "default": null,
        "name": "resource_type",
        "null": false,
        "type": "string"
      },
      "name": "resource_type",
      "selected_by_default": null,
      "translated": null
    }
  },
  "className": "BundleOrderLineElement",
  "collectionKey": "bundle_order_line_elements",
  "collectionName": "bundle_order_line_elements",
  "i18nKey": "bundle_order_line_element",
  "camelizedLower": "bundleOrderLineElement",
  "name": "BundleOrderLineElement",
  "nameDasherized": "bundle-order-line-element",
  "pluralName": "bundle_order_line_elements",
  "ransackable_associations": [
    {
      "className": "BundleOrderLine",
      "collectionName": "bundle_order_lines",
      "foreignKey": "bundle_order_line_id",
      "name": "bundle_order_line",
      "macro": "belongs_to",
      "resource_name": "BundleOrderLine",
      "through": null
    },
    {
      "className": "BundleTenantPhotoProduct",
      "collectionName": "bundle_tenant_photo_products",
      "foreignKey": "bundle_tenant_photo_product_id",
      "name": "bundle_tenant_photo_product",
      "macro": "belongs_to",
      "resource_name": "BundleTenantPhotoProduct",
      "through": null
    },
    {
      "className": "Log",
      "collectionName": "logs",
      "foreignKey": "trackable_id",
      "name": "logs",
      "macro": "has_many",
      "resource_name": "Log",
      "through": null
    },
    {
      "className": "PhotoSheetProductOrderLine",
      "collectionName": "photo_sheet_product_order_lines",
      "foreignKey": "resource_id",
      "name": "photo_sheet_product_order_line",
      "macro": "belongs_to",
      "resource_name": "PhotoSheetProductOrderLine",
      "through": null
    },
    {
      "className": "Resource",
      "collectionName": null,
      "foreignKey": "resource_id",
      "name": "resource",
      "macro": "belongs_to",
      "resource_name": null,
      "through": null
    },
    {
      "className": "Tagging",
      "collectionName": "taggings",
      "foreignKey": "resource_id",
      "name": "taggings",
      "macro": "has_many",
      "resource_name": "Tagging",
      "through": null
    },
    {
      "className": "Tag",
      "collectionName": "tags",
      "foreignKey": "tag_id",
      "name": "tags",
      "macro": "has_many",
      "resource_name": "Tag",
      "through": "taggings"
    },
    {
      "className": "WorkerPlugins::WorkplaceLink",
      "collectionName": "workplace_links",
      "foreignKey": "resource_id",
      "name": "workplace_links",
      "macro": "has_many",
      "resource_name": "WorkplaceLink",
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "bundle_order_line_id",
      "column": {
        "default": null,
        "name": "bundle_order_line_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "bundle_tenant_photo_product_id",
      "column": {
        "default": null,
        "name": "bundle_tenant_photo_product_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "id_string",
      "column": null
    },
    {
      "name": "resource_id",
      "column": {
        "default": null,
        "name": "resource_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "resource_type",
      "column": {
        "default": null,
        "name": "resource_type",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    }
  ],
  "ransackable_scopes": [
    {
      "name": "in_current_workplace"
    },
    {
      "name": "soft_deleted_filter"
    },
    {
      "name": "sort_by_in_current_workplace_asc"
    },
    {
      "name": "sort_by_in_current_workplace_desc"
    }
  ],
  "relationships": [
    {
      "className": "BundleOrderLine",
      "collectionName": "bundle_order_lines",
      "foreignKey": "bundle_order_line_id",
      "name": "bundle_order_line",
      "macro": "belongs_to",
      "resource_name": "BundleOrderLine",
      "through": null
    },
    {
      "className": "PhotoSheetProductOrderLine",
      "collectionName": "photo_sheet_product_order_lines",
      "foreignKey": "resource_id",
      "name": "photo_sheet_product_order_line",
      "macro": "belongs_to",
      "resource_name": "PhotoSheetProductOrderLine",
      "through": null
    }
  ],
  "paramKey": "bundle_order_line_element",
  "primaryKey": "id"
}

/** Frontend model for BundleOrderLineElement. */
export default class BundleOrderLineElement extends BaseModel {
  /** @returns {typeof modelClassData} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {string} */
  bundleTenantPhotoProductId() {
    return this.readAttributeUnderscore("bundle_tenant_photo_product_id")
  }

  /** @returns {boolean} */
  hasBundleTenantPhotoProductId() {
    const value = this.bundleTenantPhotoProductId()

    return this._isPresent(value)
  }

  /** @returns {string} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {string} */
  resourceType() {
    return this.readAttributeUnderscore("resource_type")
  }

  /** @returns {boolean} */
  hasResourceType() {
    const value = this.resourceType()

    return this._isPresent(value)
  }

  /** @returns {import("./bundle-order-line.js").default | null} */
  bundleOrderLine() {
    return this._readBelongsToReflection({modelClass: BundleOrderLine, reflectionName: "bundle_order_line"})
  }

  /** @returns {Promise<import("./bundle-order-line.js").default | null>} */
  loadBundleOrderLine() {
    if (!("bundleOrderLineId" in this)) throw new Error("Foreign key method wasn't defined: bundleOrderLineId")

    const id = this.bundleOrderLineId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "bundle_order_line",
        model: this,
        modelClass: BundleOrderLine
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./bundle-order-line.js").default | null>} */
  ensureBundleOrderLineLoaded() {
    return this.ensureAssociationLoaded("bundle_order_line")
  }

  /** @returns {import("./photo-sheet-product-order-line.js").default | null} */
  photoSheetProductOrderLine() {
    return this._readBelongsToReflection({modelClass: PhotoSheetProductOrderLine, reflectionName: "photo_sheet_product_order_line"})
  }

  /** @returns {Promise<import("./photo-sheet-product-order-line.js").default | null>} */
  loadPhotoSheetProductOrderLine() {
    if (!("resourceId" in this)) throw new Error("Foreign key method wasn't defined: resourceId")

    const id = this.resourceId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "photo_sheet_product_order_line",
        model: this,
        modelClass: PhotoSheetProductOrderLine
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./photo-sheet-product-order-line.js").default | null>} */
  ensurePhotoSheetProductOrderLineLoaded() {
    return this.ensureAssociationLoaded("photo_sheet_product_order_line")
  }
}
